export default __webpack_public_path__ + "static/media/welcome.3ef34dca.svg";